import { h, Component } from 'preact';
import classnames from 'classnames/dedupe';
import Button from '../../../elements/material-button';
import LeftArrow from '../../../icons/left-arrow';
import RightArrow from '../../../icons/right-arrow';
import './index.scss';
// TODO: refactoring code
// Add default props
export default class Carousel extends Component {

	constructor(props) {
		super(props);

		this.renderItems = props.items;
		this.state = {
			currentSlide: this.props.currentSlide ? this.props.currentSlide : 0,
			loaded: {
				0: true,
				1: props.items.length >=2 ? true : undefined
			}
		};

		if (props.infiniteScrolling) {
			this.renderItems = this.addClonedItems(props.items);
		}

		this.itemWidth = null;
		this.itemRef = null;
		this.scrollRef = null;
		this.noOfItems = null;
		this.widthArray = [];
		this.touchStarted = false;
		this.touchStartX = null;
		this.touchStartY = null;
		this.touchEndX = null;
		this.touchEndY = null;
	}
	
	componentWillMount() {
		if (this.props.getControls) {
			this.props.getControls({
				getCurrentSlide: () => this.state.currentSlide,
				goToSlide: this.scrollToUpdatedSlide,
			});
		}
	}

	addClonedItems = (array) => {
		const newArray = array.map((v) => {
			let isSliding = false;
			v.attributes.onMouseUp = () => {
				if (this.inTransition) {
					isSliding = true;
				}
			};
			v.attributes.onClick = (e) => {
				if (isSliding) {
					e.preventDefault();
					e.stopPropagation();
					return false;
				}
			};
			return v;
		});
		newArray.unshift(array.slice(-1)[0]);
		newArray.push(array[0]);
		return newArray;
	}

	componentDidMount() {
		if (this.itemRef) {
			if (this.props.autoPlay) {
				this.onBlur = () => {
					this.pause = true;
				};
				this.onFocus = () => {
					this.resetAutoPlay();
					this.pause = false;
				};
				window.addEventListener('blur', this.onBlur, { passive: true });
				window.addEventListener('focus', this.onFocus, { passive: true });
			}
			let scrollWidth = window.innerWidth;
			if (this.itemRef.parentElement) {
				scrollWidth = this.itemRef.parentElement.offsetWidth;
			}
			const { slidesToShow = 1, centerMode = false, edgeWidth = 15, infiniteScrolling = false, fixedWidth } = this.props;

			this.edgeWidth = edgeWidth;

			this.itemWidth = scrollWidth / slidesToShow;
			if (centerMode) {
				this.itemWidth = (scrollWidth - (2 * this.edgeWidth)) / slidesToShow;
			}
			if (fixedWidth) {
				this.itemWidth = fixedWidth < window.innerWidth - (edgeWidth * 2) ? fixedWidth : window.innerWidth - (edgeWidth * 2);
				this.edgeWidth = (scrollWidth - this.itemWidth) / 2;
				this.scrollToUpdatedSlide(0);
			}
			if (infiniteScrolling) {
				const updatedSlide = this.state.currentSlide;
				const slidePosition = this.getSlidePosition(updatedSlide);
				this.scrollRef.style.transform = `translate(${slidePosition}px, ${0}px)`;
				this.setState({
					slidePosition
				});
			}
			this.resetAutoPlay();
		}
	}

	handleSlide = (e) => {
		this.touchEndX = e.pageX;
		this.touchEndY = e.pageY;
		const diffX = Math.abs(this.touchEndX) - Math.abs(this.touchStartX);
		const slidePosition = this.state.slidePosition || 0;
		this.animateSlide(this.scrollRef, '0s', { X: diffX + slidePosition });
	}

	getSlidePosition = (updatedSlide) => {
		const { infiniteScrolling, slidesToScroll, centerMode } = this.props;
		let updatedSlideAccordingToProps = updatedSlide;
		if (infiniteScrolling) {
			updatedSlideAccordingToProps += 1;
		}
		let slidePosition = -(this.itemWidth) * updatedSlideAccordingToProps;
		if (centerMode) {
			slidePosition += this.edgeWidth;
		}
		return slidePosition;
	}

	getUpdatedSlide = (diffX, length) => {
		let updatedSlide, direction = 0;
		const { infiniteScrolling, items } = this.props;
		if (diffX >= 50) {
			direction = -1;
		}
		else if (diffX <= -50) {
			direction = 1;
		}
		const currentSlide = this.state.currentSlide;
		updatedSlide = currentSlide + direction;
		if (updatedSlide < 0) {
			updatedSlide = 0;
			if (infiniteScrolling) {
				updatedSlide = length - 1;
			}
		}
		else if (updatedSlide > length -1) {
			updatedSlide = length - 1;
			if (infiniteScrolling) {
				updatedSlide = 0;
			}
		}
		return updatedSlide;
	}

	scrollToUpdatedSlide = (updatedSlide) => {
		if (!this.pause) {
			const { infiniteScrolling, items } = this.props;
			let slidePosition = this.getSlidePosition(updatedSlide);
			if (infiniteScrolling) {
				if ((updatedSlide === 0 && this.state.currentSlide === items.length - 1)) {
					this.animateSlide(this.scrollRef, '500ms', { X: this.state.slidePosition - this.itemWidth });
					setTimeout(() => {
						this.animateSlide(this.scrollRef, '0s', { X: slidePosition });
					}, 500);
				}
				else if ((updatedSlide === items.length - 1 && this.state.currentSlide === 0)) {
					this.animateSlide(this.scrollRef, '500ms', { X: this.state.slidePosition + this.itemWidth });
					setTimeout(() => {
						this.animateSlide(this.scrollRef, '0s', { X: slidePosition });
					}, 500);
				}
				else {
					this.animateSlide(this.scrollRef, '500ms', { X: slidePosition });
				}
			}
			else {
				this.animateSlide(this.scrollRef, '500ms', { X: slidePosition });
			}
			this.setState(prevState => ({
				currentSlide: updatedSlide,
				slidePosition,
				loaded: Object.assign(prevState.loaded, { [updatedSlide]: true, [updatedSlide+1]: true })
			}));
		}
	}

	animateSlide = (ref = this.scrollRef, duration = '1s', position) => {
		const { X = 0, Y = 0 } = position;
		ref.style['transition-duration'] = duration;
		ref.style.transform = `translate(${X}px, ${Y}px)`;
	}

	handleSlideStart = (e) => {
		this.touchStarted = true;
		this.pause = true;
		this.touchStartX = e.pageX;
		this.touchStartY = e.pageY;
	}

	handleSlideEnd = (e) => {
		this.touchStarted = false;
		if (!this.touchEndX) {
			return;
		}
		const diffX = Math.abs(this.touchEndX) - Math.abs(this.touchStartX);
		const { items } = this.props;
		let updatedSlide = this.getUpdatedSlide(diffX, items.length);
		this.resetAutoPlay();
		this.pause = false;
		this.scrollToUpdatedSlide(updatedSlide);
		this.touchEndX = null;
		this.touchEndY = null;
		this.touchStartX = null;
		this.touchStartY = null;
	}

	handleTouchMove = (e) => {
		if (this.touchStarted) {
			this.handleSlide(e.touches[0]);
		}
	}

	handleTouchStart = (e) => {
		this.handleSlideStart(e.touches[0]);
	}

	handleTouchEnd = (e) => {
		if (this.touchStarted) {
			this.handleSlideEnd(e.touches[0]);
		}
	}

	handleTouchLeave = (e) => {
		if (this.touchStarted) {
			this.handleSlideEnd(e.touches[0]);
		}
	}

	handleMouseDown = (e) => {
		this.handleSlideStart(e);
	}

	handleMouseMove = (e) => {
		if (this.touchStarted) {
			this.inTransition = true;
			this.handleSlide(e);
		}
	}

	handleMouseUp = (e) => {
		if (this.touchStarted) {
			this.handleSlideEnd(e);
			this.inTransition = false;
		}
	}

	handleMouseOut = (e) => {
		if (this.touchStarted) {
			this.handleSlideEnd(e);
		}
	}

	gotoSlide = (slidePosition) => {
		const {infiniteScrolling, items} = this.props;
		const {updatedSlide} = this.state;
		if (infiniteScrolling) {
			if ((updatedSlide === 0 && this.state.currentSlide === items.length - 1)) {
				this.animateSlide(this.scrollRef, '500ms', { X: this.state.slidePosition - this.itemWidth });
				setTimeout(() => {
					this.animateSlide(this.scrollRef, '0s', { X: slidePosition });
				}, 500);
			}
			else if ((updatedSlide === items.length - 1 && this.state.currentSlide === 0)) {
				this.animateSlide(this.scrollRef, '500ms', { X: this.state.slidePosition + this.itemWidth });
				setTimeout(() => {
					this.animateSlide(this.scrollRef, '0s', { X: slidePosition });
				}, 500);
			}
			else {
				this.animateSlide(this.scrollRef, '500ms', { X: slidePosition });
			}
		}
		else {
			this.animateSlide(this.scrollRef, '500ms', { X: slidePosition });
		}
		this.setState(prevState => ({
			currentSlide: updatedSlide,
			slidePosition,
			loaded: Object.assign(prevState.loaded, { [updatedSlide]: true, [updatedSlide+1]: true })
		}));
	}

	nextSlide = (e) => {
		const { currentSlide } = this.state;
		const { items, slidesToShow, slidesToScroll=1 } = this.props;
		if(currentSlide + 1 <= items.length - slidesToShow) {
			// let slidePosition = this.getSlidePosition(currentSlide+1);
			this.scrollToUpdatedSlide(currentSlide+slidesToScroll);
			this.touchEndX = null;
			this.touchEndY = null;
			this.touchStartX = null;
			this.touchStartY = null;
		}
		this.props.nextSlide && this.props.nextSlide(e,currentSlide+1);
	}

	prevSlide = (e) => {
		const { currentSlide } = this.state;
		const { slidesToScroll=1 } = this.props;
		if(currentSlide - 1 >= 0) {
			// let slidePosition = this.getSlidePosition(currentSlide-1);
			this.scrollToUpdatedSlide(currentSlide-slidesToScroll);
			this.touchEndX = null;
			this.touchEndY = null;
			this.touchStartX = null;
			this.touchStartY = null;
		}
		this.props.prevSlide && this.props.prevSlide(e,currentSlide-1);
	}

	componentWillReceiveProps(nextProps) {
		if (this.props.items != nextProps.items) {
			this.renderItems = nextProps.items;
			if (nextProps.infiniteScrolling) {
				this.renderItems = this.addClonedItems(nextProps.items);
			}
		}
		if (nextProps.currentSlide && this.state.currentSlide != nextProps.currentSlide) {
			this.scrollToUpdatedSlide(nextProps.currentSlide);
		}
	}

	componentWillUnmount() {
		clearInterval(this.autoPlay);
		window.removeEventListener('blur', this.onBlur);
		window.removeEventListener('focus', this.onFocus);
	}

	resetAutoPlay = () => {
		clearInterval(this.autoPlay);
		if (this.props.autoPlay) {
			this.autoPlay = setInterval(() => this.scrollToUpdatedSlide((this.state.currentSlide + 1) % (this.renderItems.length - 2)), this.props.autoPlayTimeout);
		}
	};


	render() {

		// TODO: Handle infinite scrolling
		// TODO: Draggable false on images
		// GOOD TO HAVE: Lazy loading images, or lazy rendering
		const { items, dots = false, buttons = false, buttonsPosition = 'top', buttonsSize='big', slidesToShow, pagination = true, slidesToScroll=1, focusActive=false } = this.props;
		const { loaded, currentSlide } = this.state;
		
		let buttonsDivClass = '';
		if(buttons) {
			buttonsDivClass = classnames('qc-carousel__buttons',buttonsPosition, buttonsSize);
		}
		let width = 0;
		if (!items) {
			return null;
		}
		if (!this.noOfItems) {
			this.noOfItems = items.length;
		}
		if (this.itemWidth) {
			width = this.itemWidth * (this.renderItems.length + 1);
		}
		const page = 1 + Number((currentSlide/slidesToShow).toFixed());

		return (<div class="qc-carousel"><div ref={(ref) => { this.itemRef = ref; }} class="qc-carousel__track">
		{buttons && <div class={buttonsDivClass}>
		{pagination && <p>{`${page} of ${(items.length/slidesToShow).toFixed()}`}</p>}
		<Button onClick={this.prevSlide} disabled={!(currentSlide - 1 >= 0)}><LeftArrow /></Button>
		<Button onClick={this.nextSlide} disabled={!(currentSlide + 1 <= items.length - slidesToShow)}><RightArrow /></Button>
		</div>}
			<div
				class="qc-carousel__list"
				ref={(ref) => { this.scrollRef = ref; }}
				onTouchMove={this.handleTouchMove}
				onTouchStart={this.handleTouchStart}
				onTouchEnd={this.handleTouchEnd}
				onTouchLeave={this.handleTouchLeave}
				style={{ width }}
				onMouseDown={this.handleMouseDown}
				onMouseMove={this.handleMouseMove}
				onMouseUp={this.handleMouseUp}
				onMouseOut={this.handleMouseOut}
			>
				{this.renderItems.map((v, index) => (<div key={index} class="qc-carousel__item" style={{ width: this.itemWidth , opacity: (focusActive) ? ((this.state.currentSlide == index) ? 1 : 0.2) : 1}}>{v}</div>))}
			</div>

		</div>

		{dots && <div class="qc-carousel__dots">
			{this.props.items.map((v, index) => (<a class={index === this.state.currentSlide ? 'active' : ''} onClick={() => this.scrollToUpdatedSlide(index)}>{index}</a>))}
		</div>}

		</div>);
	}
}

Carousel.defaultProps = {
	autoPlay: false,
	autoPlayTimeout: 5000
};



// WEBPACK FOOTER //
// ../q-mdc/quikr/core/quikrCarousel/index.js